var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrintTag = function SvgPrintTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5901 13.41L13.4201 20.58C13.2344 20.766 13.0138 20.9135 12.771 21.0141C12.5282 21.1148 12.268 21.1666 12.0051 21.1666C11.7423 21.1666 11.482 21.1148 11.2392 21.0141C10.9964 20.9135 10.7759 20.766 10.5901 20.58L2.00012 12V2H12.0001L20.5901 10.59C20.9626 10.9647 21.1717 11.4716 21.1717 12C21.1717 12.5284 20.9626 13.0353 20.5901 13.41Z",
    stroke: "#363840",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00012 7H7.01012",
    stroke: "#363840",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPrintTag;